// extracted by mini-css-extract-plugin
export var header = "_t9-1";
export var maskBottom = "_t9-6";
export var maskMiddle = "_t9-7";
export var maskTop = "_t9-5";
export var root = "_t9-0";
export var scrollDownButton = "_t9-3";
export var scrollDownButtonHidden = "_t9-4";
export var viewport = "_t9-2";